module.exports = __webpack_public_path__ + "img/Pablo-Serrano-Poster-03.f759ca47.jpg";